import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useIsMobile } from "../../../device/selectors";
import { getCookie } from "../../../../../../helpers/cookies";
import { useRaffleDrawsHistoryLoading, useSmarticoRaffleDrawsById } from "../../store";
import GeneralRaffleCard from "./GeneralRaffleCard";
import { SmarticoRaffleDrawIds } from "../../interfaces/SmarticoRaffleDrawIds";
import InfoIcon from "@/app/shared-components/icons/InfoIcon";
import { useRaffleContext } from "@/app/(custom-header)/spring-daily-raffle/context";

const TicketsDisplayerRender = () => {
  const isMobile = useIsMobile();
  const { isEndState } = useRaffleContext();
  const isAuth = getCookie("BotB.Authenticated") === "true";
  const allDraws = useSmarticoRaffleDrawsById([SmarticoRaffleDrawIds.HOURLY_DRAW, SmarticoRaffleDrawIds.GRAND_DRAW], {
    showExpired: false,
  });
  const areRaffleDrawsLoading = useRaffleDrawsHistoryLoading();

  const dataNotLoaded = !allDraws || allDraws.length === 0 || areRaffleDrawsLoading;

  const spaceBetween = isMobile ? 12 : 32;
  const slidesPerView = isMobile ? 1.2 : 3;

  const widthPercent = 100 / slidesPerView;
  const spaceCalc = (spaceBetween / slidesPerView) * (slidesPerView - 1);

  const placeholderCount = 2;
  const isSingleSlide = (dataNotLoaded ? placeholderCount : allDraws.length) === 1;
  const slidesOffset = isSingleSlide ? 0 : 10;

  return (
    <>
      <div className={"w-full -mt-7.5 lg:-mt-[72px] mb-8 lg:mb-[56px] mx-auto lg:max-w-[1412px]"}>
        {isEndState ? null : (
          <Swiper
            slidesPerView={slidesPerView}
            spaceBetween={spaceBetween}
            slidesOffsetBefore={slidesOffset}
            slidesOffsetAfter={slidesOffset}
            centerInsufficientSlides={!isMobile || isSingleSlide}
            className={"tombola-swiper !pb-2"}>
            {dataNotLoaded
              ? Array(placeholderCount)
                  .fill(0)
                  .map((_, i) => (
                    <SwiperSlide
                      key={`loading-${i}`}
                      className="!h-auto"
                      style={{
                        width: `calc(${widthPercent}% - ${spaceCalc}px)`,
                        marginRight: `${spaceBetween}px`,
                      }}>
                      <GeneralRaffleCard dataNotLoaded={true} />
                    </SwiperSlide>
                  ))
              : allDraws.map((raffleDraw, index) => (
                  <SwiperSlide
                    key={`draw-${index}`}
                    className="!h-auto"
                    style={{
                      width: `calc(${widthPercent}% - ${spaceCalc}px)`,
                      marginRight: `${spaceBetween}px`,
                    }}>
                    <GeneralRaffleCard dataNotLoaded={false} drawId={raffleDraw.id} />
                  </SwiperSlide>
                ))}
          </Swiper>
        )}
        {isAuth && (
          <div className={"px-3 lg:px-6 lg:flex lg:justify-center"}>
            <div className={"inline-flex items-center mt-1 text-gray-1"}>
              <InfoIcon variant={2} className={"size-5 lg:size-6 mr-1 text-[#696971]"} />
              <span className={"text-[#696971] font-jost text-xs font-normal leading-4 lg:text-sm lg:leading-5"}>
                The tickets for the daily draws reset every day at 6 PM
                {/* The tickets for the daily draws reset every day at 9:30 PM */}
              </span>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TicketsDisplayerRender;
